import { Button, Modal, Select, Tooltip } from "antd"
import { FC, useEffect, useState } from "react"
import { useTypedSelector } from "../../../hooks/useTypedSelector"
import { buildAudienceOptions } from "../hooks/helpers/audienceOptions.helper"
import styles from "./SbSelectAudience.module.scss"

interface ISbSelectAudienceProps {
  audienceId: string | null
  onChange: (audienceId: string) => void
}

const DEFAULT_LABEL = "Select Audience"

const SbSelectAudience: FC<ISbSelectAudienceProps> = ({ audienceId, onChange }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [value, setValue] = useState<string | null>(audienceId)

  const { audiences, loaded } = useTypedSelector((state) => state.audiences)

  useEffect(() => {
    setValue(audienceId)
  }, [audienceId])

  const options = buildAudienceOptions(audiences)

  function resolveLabel(): string {
    if (!value) {
      return DEFAULT_LABEL
    }

    return options.find((option) => option.value === value)?.label ?? value
  }

  function handleOk() {
    if (value) {
      onChange(value)
    }

    setIsModalOpen(false)
  }

  function handleCancel() {
    setValue(audienceId)
    setIsModalOpen(false)
  }

  return (
    <div className={styles.audienceCell}>
      Audience:
      <Tooltip title={value ?? DEFAULT_LABEL}>
        <Button className={styles.audienceButton} onClick={() => setIsModalOpen(true)}>
          {resolveLabel()}
        </Button>
      </Tooltip>
      <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel} width={"60%"}>
        <Select
          options={options}
          value={value}
          onChange={(next) => setValue(next)}
          style={{ width: "100%" }}
          loading={loaded}
          disabled={loaded}
          placeholder={DEFAULT_LABEL}
        />
      </Modal>
    </div>
  )
}

export default SbSelectAudience
